import { documentationActions } from '../../actions/constant';

const {
  REQUEST_PREPARE_PROGREE_NOTE,
  SUCCESS_PREPARE_PROGREE_NOTE,
  FAILURE_PREPARE_PROGREE_NOTE,
  RESET_PREPARE_PROGREE_NOTE,
} = documentationActions;

const intitialstate: object = {
  response: null,
  isGetPrepareNote: false,
  loading: false,
};

export const getPrepareProgressNoteReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case REQUEST_PREPARE_PROGREE_NOTE:
      return {
        ...state,
        loading: true,
      };

    case SUCCESS_PREPARE_PROGREE_NOTE: {
      return {
        ...state,
        isGetPrepareNote: true,
        response: action.payload,
        loading: false,
      };
    }

    case FAILURE_PREPARE_PROGREE_NOTE:
      return {
        ...state,
        isGetPrepareNote: false,
        response: action.payload,
        loading: false,
      };

    case RESET_PREPARE_PROGREE_NOTE: {
      return intitialstate;
    }

    default:
      return state;
  }
};
